import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { SharedService } from '../shared.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { FirstLetterUpperCase } from '../pipe/firstletteruppercase.pipe';
import { LowerCasePipe } from '@angular/common';
import { GlobalVariable } from '../global';
import { TDUModel } from '../models/shared-models';

declare var google;

@Component({
	selector: 'app-home-msite',
	templateUrl: './home-msite.component.html',
	styleUrls: ['./home-msite.component.css'],
	providers: [LowerCasePipe]
})
export class HomeMsiteComponent implements OnInit {
	// validation field required
	serviceAddressFormControl = new FormControl('', [Validators.required]);
	apartmentFormControl = new FormControl('', [Validators.required]);
	// public variaable define
	public zipcode: string;
	public service_address_search: string;
	public tdus: Array<TDUModel>;
	public duns: string;
	public is_component_load: boolean;
	public is_apt_exist: boolean;
	public error_message: string;
	public apt_units: any = [];
	public apt_unit: string;
	public apartment_list: any = [];
	public apartment_obs: Observable<string[]>;
	public is_loader: boolean;
	public esiid: string;
	public tdu: string;
	public multiple: boolean;
	public language: string;
	public base_url: string;
	public old_key: number;
	public which_event: string;
	public places: any;
	public is_address_addlis: boolean;
	public search_val: any;

	// define constructor
	constructor(private activatedRoute: ActivatedRoute, private sharedService: SharedService,
		private router: Router, private localStorageService: LocalStorageService,
		private firstLetterPipe: FirstLetterUpperCase, private lowerCasePipe: LowerCasePipe) {
		this.sharedService.setHeaderTitle('home_msite');
		this.base_url = GlobalVariable.BASE_API_URL;
		this.language = 'en';
		const ref = '' + document.referrer;
		if (ref.includes(GlobalVariable.HOST_M_SITE_ES)) {
			this.language = 'es';
			this.localStorageService.set('msite_base_url', 'https://es.pogoenergy.com/');
			// setTimeout(function(){
			// 	const spanBtn = document.getElementById('spanish');
			// 	if (spanBtn != undefined) {
			// 	 	spanBtn.click();
			// 	}
			// }, 6000);
		} else {
			this.language = 'en';
			this.localStorageService.set('msite_base_url', 'https://www.pogoenergy.com/');
			// setTimeout(function(){
			// 	const engBtn = document.getElementById('english');
			// 	if (engBtn != undefined) {
			// 	 	engBtn.click();
			// 	}
			// }, 6000);
		}
		this.is_component_load = true;
		this.zipcode = '';
		this.duns = '';
		this.apt_unit = '';
		this.is_apt_exist = false;
		this.is_loader = false;
		this.esiid = '';
		this.tdu = '';
		this.multiple = false;
		this.zipcode = '';

		this.sharedService.getElectricUtilityProviders().then(activeTdus => {
			this.tdus = activeTdus;
		});
	}

	// validate apt or unit
	validateApt() {
		document.getElementById('home_next').setAttribute('disabled', '');
		this.apt_unit = '';
	}

	addClass() {
		setTimeout(function () {
			// tslint:disable-next-line:max-line-length
			const setPos = <HTMLScriptElement>document.getElementsByClassName('cdk-overlay-pane')[document.getElementsByClassName('cdk-overlay-pane').length - 1];
			if (!setPos.classList.contains('home-msite-apart-auto-cls')) {
				setPos.classList.add('home-msite-apart-auto-cls');
			}
			setPos.parentElement.classList.add('cdk-overlay-container-static');
		}, 10);

		setTimeout(function () {
			const setcls = <HTMLScriptElement>document.getElementsByClassName('sidenav-container')[0];
			setcls.classList.add('nav-cls');
		}, 10);
	}

	removeClass() {
		const setcls = <HTMLScriptElement>document.getElementsByClassName('sidenav-container')[0];
		setcls.classList.remove('nav-cls');
		const removeCls = <HTMLScriptElement>document.getElementsByClassName('cdk-overlay-container')[0];
		if (removeCls.classList.contains('cdk-overlay-container-static')) {
			removeCls.classList.remove('cdk-overlay-container-static');
		}

	}

	findApartUnit(search_val: any) {
		const enter_key = search_val.keyCode || search_val.which;
		if (search_val.target.value === '') {
			document.getElementById('is_error_address').setAttribute('style', 'display:none');
			document.getElementById('is_error_address_yellow').setAttribute('style', 'display:none');
		}
		if (search_val.type === 'keyup' && (enter_key === 13) || (this.old_key === 17 && enter_key === 86) ||
			(this.old_key === 86 && enter_key === 17)) {
			document.getElementById('apartment').blur();
		}
		if (search_val.type === 'focusout') {
			if (search_val.target.value !== '') {
				this.chooseApartUnit(search_val.target.value, '');
			}
		}
		this.old_key = enter_key;
	}

	// find tdus using address or zipcode
	getTDUs() {
		if (this.duns !== '' && this.esiid !== '') {
			var selectedTdu = this.tdus.find((x) => x.duns == this.duns);
			window.top.location.href = this.base_url + 'enroll/esiid/' + this.esiid + '/tdu/' + selectedTdu.tduCode;
		}
		else if (this.multiple) {
			window.top.location.href = this.base_url + 'enroll/zipcode/' + this.zipcode;
		}
		else if (!this.multiple && this.tdu !== '') {
			window.top.location.href = this.base_url + 'enroll/zipcode/' + this.zipcode + '/tdu/' + this.tdu;
		}
		else {
			document.getElementById('is_error_address').setAttribute('style', 'display:none');
			document.getElementById('is_error_address_yellow').setAttribute('style', 'display:none');
			document.getElementById('home_next').setAttribute('disabled', '');
			document.getElementById('is_apt_exist').setAttribute('style', 'display:none');
		}
	}

	// getAddress method match address from ercot and validate it
	getAddress(search_val: any) {
		const enter_key = search_val.keyCode || search_val.which;
		const this_of_comp = this;
		this.which_event = '';
		this.search_val = search_val;
		if (!this.is_address_addlis) {
			google.maps.event.addListener(this_of_comp.places, 'place_changed', function () {
				if (this_of_comp.places !== undefined) {
					const place = this_of_comp.places.getPlace();
					this_of_comp.getPlaces(place, this_of_comp, this_of_comp.search_val, 'place');
				}
			});
			this.is_address_addlis = true;
		}
		if (search_val.target.value === '') {
			this.apt_unit = '';
			this.esiid = '';
			this.apartment_list = [];
			if (document.getElementById('is_error_address') !== undefined) {
				document.getElementById('is_error_address').setAttribute('style', 'display:none');
			}
			if (document.getElementById('is_error_address_yellow') !== undefined) {
				document.getElementById('is_error_address_yellow').setAttribute('style', 'display:none');
			}
			if (document.getElementById('is_apt_exist') !== undefined) {
				document.getElementById('is_apt_exist').setAttribute('style', 'display:none');
			}
			if (document.getElementById('home_next') !== undefined) {
				document.getElementById('home_next').setAttribute('disabled', '');
			}
		}
		if (search_val.type === 'keyup' && (enter_key === 13)) {
			document.getElementById('service_address_id').blur();
		}
		if (search_val.type === 'focusout') {
			this.apt_unit = '';
			this.esiid = '';
			this.apartment_list = [];
			document.getElementById('is_error_address').setAttribute('style', 'display:none');
			document.getElementById('is_error_address_yellow').setAttribute('style', 'display:none');
			document.getElementById('home_next').setAttribute('disabled', '');
			document.getElementById('is_apt_exist').setAttribute('style', 'display:none');
			if (search_val.target.value !== '') {
				document.getElementById('is_loader').setAttribute('style', '');
				const geocoder = new google.maps.Geocoder();
				geocoder.geocode({ 'address': search_val.target.value }, function (results, status) {
					if (status === google.maps.GeocoderStatus.OK) {
						const place = results[0];
						this_of_comp.getPlaces(place, this_of_comp, search_val, 'geocode');
					} else {
						document.getElementById('home_next').setAttribute('disabled', '');
						document.getElementById('is_loader').setAttribute('style', 'display:none');
					}
				});
			}
		}
		this.old_key = enter_key;
	}

	getPlaces(place: any, this_of_comp: any, search_val: any, which_event: any) {
		if (which_event !== 'place' || (which_event === 'place' && this_of_comp.which_event === 'ex_case')) {
			this_of_comp.which_event = '';
			let apt = '';
			let street_number = '';
			let street_address = '';
			let zipcode = '';
			let city = '';
			if (place !== undefined) {
				if (place['address_components'] !== undefined) {
					for (let i = 0; i < place['address_components'].length; i++) {
						if (place['address_components'][i]['types'][0] === 'postal_code') {
							zipcode = place['address_components'][i]['short_name'];
						}
						if (place['address_components'][i]['types'][0] === 'street_number') {
							street_number = place['address_components'][i]['short_name'];
						}
						if (place['address_components'][i]['types'][0] === 'locality') {
							city = place['address_components'][i]['short_name'];
						}
						if (place['address_components'][i]['types'][0] === 'subpremise') {
							apt = place['address_components'][i]['short_name'];
						}
						if (place['address_components'][i]['types'][0] === 'route') {
							street_address = place['address_components'][i]['short_name'];
						}
					}

					if (street_address !== '' && zipcode !== '') {
						if (!(which_event === 'geocode' && street_number.indexOf('-') > -1)) {
							this_of_comp.addressMatch(apt, street_number, city, street_address, zipcode, search_val.target.value);
						} else {
							this_of_comp.which_event = 'ex_case';
							google.maps.event.trigger(this_of_comp.places, 'place_changed');
							return false;
						}
					} else if (zipcode !== '') {
						this_of_comp.zipcode = zipcode;
						this_of_comp.sharedService.getTDUs({ 'zipcode': zipcode })
							.then(res => {
								const loader = document.getElementById('is_loader');
								loader.setAttribute('style', 'display:none');
								if (res.status === 'success') {
									const dis = document.getElementById('home_next');
									dis.removeAttribute('disabled');
									dis.focus();
									if (res.multiple) {
										this_of_comp.multiple = true;
									} else {
										this_of_comp.multiple = false;
										this_of_comp.tdu = res.tdu[0];
									}
								} else {
									document.getElementById('is_error_address_yellow').removeAttribute('style');
									document.getElementById('is_error_address_yellow').innerHTML =
										'<p>' + this_of_comp.sharedService.getErrorMessage('address_not_found') + '</p>';
									document.getElementById('home_next').setAttribute('disabled', '');
								}
							});
					} else {
						document.getElementById('is_error_address_yellow').removeAttribute('style');
						document.getElementById('is_error_address_yellow').innerHTML =
							'<p>' + this_of_comp.sharedService.getErrorMessage('address_not_found') + '</p>';
						document.getElementById('is_loader').setAttribute('style', 'display:none');
						document.getElementById('home_next').setAttribute('disabled', '');
						document.getElementById('is_loader').setAttribute('style', 'display:none');
					}
				} else {
					document.getElementById('is_error_address_yellow').removeAttribute('style');
					document.getElementById('is_error_address_yellow').innerHTML =
						'<p>' + this_of_comp.sharedService.getErrorMessage('address_not_found') + '</p>';
					document.getElementById('is_loader').setAttribute('style', 'display:none');
					document.getElementById('home_next').setAttribute('disabled', '');
					document.getElementById('is_loader').setAttribute('style', 'display:none');
				}
			} else {
				document.getElementById('is_error_address_yellow').removeAttribute('style');
				document.getElementById('is_error_address_yellow').innerHTML =
					'<p>' + this_of_comp.sharedService.getErrorMessage('address_not_found') + '</p>';
				document.getElementById('is_loader').setAttribute('style', 'display:none');
				document.getElementById('home_next').setAttribute('disabled', '');
				document.getElementById('is_loader').setAttribute('style', 'display:none');
			}
		}
	}

	addressMatch(apt, street_number, city, street_address, zipcode, search_address) {
		if (zipcode !== '' && street_address !== '') {
			this.sharedService.getServiceAddressesByGoogle(
				{ 'GoogleStreet_Number': street_number, 'GoogleStreet': street_address, 'GooglePostal_Code': zipcode, 'GoogleCity': city })
				.then(res => {
					if (res.result.length > 0) {
						if (res.result.length === 1) {
							const address_obj = res.result[0];
							this.apt_units = res.result;
							for (let i = 0; i < this.apt_units.length; i++) {
								if (this.apt_units[i].apt_unit != null && this.apt_units[i].apt_unit !== '') {
									let apartment = this.apt_units[i].apt_unit;
									if (apartment.includes(' ')) {
										apartment = apartment.split(' ')[1];
									}
									this.apartment_list.push(apartment);
									this.apt_unit = apartment;
								}
							}
							this.apartment_obs =
								this.apartmentFormControl.valueChanges.startWith(null).map(val => val ? this.filter(val) : this.apartment_list.slice());
							const len = document.getElementsByTagName('body')[0];
							len.click();
							document.getElementById('is_loader').setAttribute('style', 'display:none');
							this.chooseApartUnit('', address_obj);
						} else {
							const loader = document.getElementById('is_loader');
							loader.setAttribute('style', 'display:none');
							this.apt_units = res.result;
							for (let i = 0; i < this.apt_units.length; i++) {
								if (this.apt_units[i].apt_unit != null && this.apt_units[i].apt_unit !== '') {
									let apartment = this.apt_units[i].apt_unit;
									if (apartment.includes(' ')) {
										apartment = apartment.split(' ')[1];
									}
									this.apartment_list.push(apartment);
									if (this.lowerCasePipe.transform(apt) === this.lowerCasePipe.transform(apartment)) {
										this.apt_unit = apartment;
										const len = document.getElementsByTagName('body')[0];
										len.click();
										this.chooseApartUnit(apartment, '');
									}
								}
							}
							if (this.apartment_list.length > 0) {
								this.apartment_obs =
									this.apartmentFormControl.valueChanges.startWith(null).map(val => val ? this.filter(val) : this.apartment_list.slice());
								document.getElementById('is_apt_exist').removeAttribute('style');
								document.getElementById('is_error_address').setAttribute('style', 'display:none');
								if (apt === '') {
									document.getElementById('apartment').focus();
								}

							} else {
								for (let i = 0; i < this.apt_units.length; i++) {
									if (this.apt_units[i].street_number != null && this.apt_units[i].street_number !== '') {
										if (street_number !== '' &&
											this.lowerCasePipe.transform(street_number) === this.lowerCasePipe.transform(this.apt_units[i].street_number)) {
											this.chooseApartUnit('', this.apt_units[i]);
										}
										if (street_number === '' && search_address.includes(this.apt_units[i].street_number)) {
											this.chooseApartUnit('', this.apt_units[i]);
										}
									}
								}
							}
						}
					} else {
						document.getElementById('is_error_address_yellow').removeAttribute('style');
						document.getElementById('is_error_address_yellow').innerHTML =
							'<p>' + this.sharedService.getErrorMessage('address_not_found') + '</p>';
						document.getElementById('is_loader').setAttribute('style', 'display:none');
						document.getElementById('home_next').setAttribute('disabled', '');
					}
				});
		} else {
			document.getElementById('is_error_address_yellow').removeAttribute('style');
			document.getElementById('is_error_address_yellow').innerHTML =
				'<p>' + this.sharedService.getErrorMessage('address_not_found') + '</p>';
			document.getElementById('home_next').setAttribute('disabled', '');
			document.getElementById('is_loader').setAttribute('style', 'display:none');
		}
	}

	// validate when select apt or unit
	chooseApartUnit(apt_number: string, address_obj: any) {
		if (apt_number !== '') {
			for (let i = 0; i < this.apt_units.length; i++) {
				let apartment = this.apt_units[i].apt_unit;
				if (apartment.includes(' ')) {
					apartment = apartment.split(' ')[1];
				}
				if (apartment === apt_number) {
					address_obj = this.apt_units[i];
					this.apt_unit = apartment;
				}
			}
		}
		this.duns = address_obj.duns;
		this.esiid = address_obj.esi_id;
		this.localStorageService.set('address_for_billing', address_obj);
		this.sharedService.validateAddress({ 'ercotId': address_obj.id })
			.then(res => {
				if (res.status === 'success') {
					document.getElementById('is_error_address').setAttribute('style', 'display:none');
					document.getElementById('is_error_address_yellow').setAttribute('style', 'display:none');
					document.getElementById('home_next').removeAttribute('disabled');
					if (address_obj.apt_unit != null && address_obj.apt_unit !== '') {
						document.getElementById('is_apt_exist').removeAttribute('style');
					}
				} else {
					if (res.color === 'yellow') {
						document.getElementById('is_error_address_yellow').removeAttribute('style');
						document.getElementById('is_error_address_yellow').innerHTML = '<p>' + res.message + '</p>';
					} else {
						document.getElementById('is_error_address').removeAttribute('style');
						document.getElementById('is_error_address').innerHTML = '<p>' + res.message + '</p>';
					}
					document.getElementById('home_next').setAttribute('disabled', '');
				}
			});
	}

	// apt autocomplete filter
	filter(val: string): string[] {
		return this.apartment_list.filter(option => option.toLowerCase().indexOf(val.toLowerCase()) === 0);
	}

	// onload method bound google api with texas
	ngOnInit() {
		const len = document.getElementsByTagName('body')[0];
		len.classList.add('body_hide');
		if (len.classList.contains('fix-overlay-div')) {
			len.classList.remove('fix-overlay-div');
		}
		const this_obj = this;
		setTimeout(function () {
			const fc_frame = document.getElementById('fc_frame');
			if (fc_frame != undefined) {
				fc_frame.setAttribute('style', 'display:none');
			}
			const address = 'Texas';
			const geocoder = new google.maps.Geocoder();
			geocoder.geocode({ 'address': address }, function (results, status) {
				if (status === google.maps.GeocoderStatus.OK) {
					const latitude = [results[0].geometry.viewport.getSouthWest().lat(),
					results[0].geometry.viewport.getSouthWest().lng()];
					const longitude = [results[0].geometry.viewport.getNorthEast().lat(),
					results[0].geometry.viewport.getNorthEast().lng()];
					const stateBound = new google.maps.LatLngBounds(
						new google.maps.LatLng(latitude[0], latitude[1]),
						new google.maps.LatLng(longitude[0], longitude[1])
					);
					const options = {
						bounds: stateBound,
						strictBounds: true,
						types: ['geocode']
					}
					// tslint:disable-next-line:no-unused-expression
					this_obj.places = new google.maps.places.Autocomplete(document.getElementById('service_address_id'), options);
				}
			});
		}, 100);

	}
}



// WEBPACK FOOTER //
// ./src/app/shared/home-msite/home-msite.component.ts